import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.background.default
    }
  },
  interim: {
    margin: 0,
    color: "#fff"
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  flexMain: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4)
  },
  search: {
    display: "flex",
    alignContent: "flex-end"
  }
}));

export default useStyles;
